<template>
    <div class="w-full flex-grow relative space-y-8">
        <div class="space-y-4">
            <cUtilsEdit @edit="goToFileField(currentFile.id, 'fileName')">
                <p class="text-lg sm:text-2xl font-semibold" :style="{ color: player.textColor }">
                    {{ currentFile.name }}
                </p>
            </cUtilsEdit>

            <MainFile />

            <MainNavigation @toggleFinish="$emit('toggleFinish')" />
        </div>

        <MainDescription v-if="currentFile.description" />
    </div>
</template>

<script>
import { mapState, mapGetters } from "vuex";
import MainFile from "./MainFile.vue";
import MainNavigation from "./MainNavigation.vue";
import MainDescription from "./MainDescription.vue";
import { usePlayerGoTo } from "@/views/tools/player/utils/usePlayerGoTo";
import cUtilsEdit from "@/views/shared/cUtilsEdit.vue";

export default {
    name: "PlayerMain",
    components: { MainFile, MainNavigation, MainDescription, cUtilsEdit },
    setup() {
        const { goToFileField } = usePlayerGoTo();
        return { goToFileField };
    },

    emits: ["toggleFinish"],
    computed: {
        ...mapState("player/view", ["player"]),
        ...mapGetters("player/view", ["currentFile"]),
    },
};
</script>
